// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"mS7Bbh"};